import { TColorPickerDataListWithCategories } from '../unifiedColorPicker/unifiedColorPicker.types'

const satinRibbonMetallicColors = [
  {
    label: 'Metallic Silver',
    value: '#D7D4D5',
  },
  {
    label: 'Metallic Gold',
    value: '#C5B46E',
  },
  {
    label: 'Metallic Copper',
    value: '#B56433',
  },
  {
    label: 'Metallic Blue',
    value: '#14409F',
  },
  {
    label: 'Metallic Red',
    value: '#C12D33',
  },
  {
    label: 'Metallic Purple',
    value: '#713DA1',
  },
  {
    label: 'Metallic Green',
    value: '#498653',
  },
  {
    label: 'Metallic Hot Pink',
    value: '#E55F94',
  },
]

const whiteSatinRibbonsColorOptionsCategories: TColorPickerDataListWithCategories =
  [
    {
      category: 'Standard Colors',
      colors: [
        {
          label: '801HL Black',
          value: '#2C2826',
        },
        {
          label: '600HL Gray',
          value: '#8D847B',
        },
        {
          label: '877HL Brown',
          value: '#624F2B',
        },
        {
          label: '375 Apple Green',
          value: '#ACD243',
        },
        {
          label: '616 Green',
          value: '#60883C',
        },
        {
          label: '689 Hunter Green',
          value: '#406F53',
        },
        {
          label: '505 Green',
          value: '#33753D',
        },
        {
          label: '601 Sears Blue',
          value: '#4EB2DF',
        },
        {
          label: '503 Light Blue',
          value: '#429AD8',
        },
        {
          label: '611 Teal',
          value: '#4CA9C5',
        },
        {
          label: '607A Blue',
          value: '#2E73C8',
        },
        {
          label: '860HL Royal',
          value: '#266096',
        },
        {
          label: '865HL Navy Blue',
          value: '#0E3068',
        },
        {
          label: '607 Purple',
          value: '#9664AF',
        },
        {
          label: '672 Purple',
          value: '#642B71',
        },
        {
          label: '506 Yellow',
          value: '#F6C66C',
        },
        {
          label: '516 Amber',
          value: '#CC8B30',
        },
        {
          label: '507 Orange',
          value: '#EF854F',
        },
        {
          label: '603 Magenta',
          value: '#EC6075',
        },
        {
          label: '612 Pink',
          value: '#E079B8',
        },
        {
          label: '255 Pink',
          value: '#D8517A',
        },
        {
          label: '820HL Red',
          value: '#C12D33',
        },
        {
          label: '604 Burgundy',
          value: '#A02A31',
        },
      ],
    },
    {
      category: 'Metallic Colors',
      colors: satinRibbonMetallicColors,
    },
  ]

const blackSatinRibbonsColorOptionsCategories: TColorPickerDataListWithCategories =
  [
    {
      category: 'Standart Colors',
      colors: [
        {
          label: 'White',
          value: 'FFFFFF',
        },
        {
          label: '801HL Black',
          value: '#2C2826',
        },
      ],
    },
    {
      category: 'Metallic Colors',
      colors: satinRibbonMetallicColors,
    },
  ]

const coffeBagsColorsOptionsCategories: TColorPickerDataListWithCategories = [
  {
    category: 'Matte Metallic Foil',
    colors: [
      {
        label: 'Matte Metallic Frost Blue',
        value: '#556E9C',
      },
      {
        label: 'Matte Metallic Red',
        value: '#DA3933',
      },
      {
        label: 'Matte Metallic Teal',
        value: '#50ACAC',
      },
      {
        label: 'Matte Metallic Purple',
        value: '#663188',
      },
    ],
  },
  {
    category: 'Satin Foil',
    colors: [
      {
        label: 'Satin Gold',
        value: '#D8C6A3',
      },
      {
        label: 'Satin Silver',
        value: '#D8C6A3',
      },
      {
        label: 'Satin Copper',
        value: '#B28851',
      },
    ],
  },
  {
    category: 'Matte Foil',
    colors: [
      {
        label: 'Matte White',
        value: '#FFFFFF',
      },
      {
        label: 'Matte Ivory',
        value: '#FDF7D5',
      },
      {
        label: 'Matte Yellow',
        value: '#F7E455',
      },
      {
        label: 'Matte Lime Green',
        value: '#B0D2A2',
      },
      {
        label: 'Matte Green',
        value: '#2E5439',
      },
      {
        label: 'Matte Baby Blue',
        value: '#50AFDC',
      },
      {
        label: 'Matte Electric Blue',
        value: '#3160A8',
      },
      {
        label: 'Matte Navy',
        value: '#1E4C7C',
      },
      {
        label: 'Matte Orange',
        value: '#E5863C',
      },
      {
        label: 'Matte Bubblegum Pink',
        value: '#E696BA',
      },
      {
        label: 'Matte Red',
        value: '#E696BA',
      },
      {
        label: 'Matte Burgundy',
        value: '#741F23',
      },
      {
        label: 'Matte Brown',
        value: '#5B2914',
      },
      {
        label: 'Matte Purple',
        value: '#583B87',
      },
      {
        label: 'Matte Gray',
        value: '#606D71',
      },
      {
        label: 'Matte Black',
        value: '#040503',
      },
    ],
  },
  {
    category: 'Metallic Foil',
    colors: [
      {
        label: 'Metallic Gold',
        value: '#AA9D53',
      },
      {
        label: 'Metallic Copper',
        value: '#8D644F',
      },
      {
        label: 'Metallic Silver',
        value: '#6C7276',
      },
      {
        label: 'Metallic Gun Metal',
        value: '#736F70',
      },
      {
        label: 'Metallic Light Green',
        value: '#768E63',
      },
      {
        label: 'Metallic Green',
        value: '#387A5D',
      },
      {
        label: 'Metallic Teal',
        value: '#438F90',
      },
      {
        label: 'Metallic Blue',
        value: '#2D638E',
      },
      {
        label: 'Metallic Rose Gold',
        value: '#BA9088',
      },
      {
        label: 'Metallic Fuchsia',
        value: '#CB5D98',
      },
      {
        label: 'Metallic Purple',
        value: '#834F8F',
      },
      {
        label: 'Metallic Red',
        value: '#BA3430',
      },
      {
        label: 'Metallic Burgundy',
        value: '#8C2824',
      },
      {
        label: 'Metallic Black',
        value: '#141623',
      },
    ],
  },
]

export {
  blackSatinRibbonsColorOptionsCategories,
  whiteSatinRibbonsColorOptionsCategories,
  coffeBagsColorsOptionsCategories,
}
